module.exports = __webpack_public_path__ + "img/image-app-forestry.193d5afa.jpg";